<template>

  <template v-if="builder.mode == 'build'">

    <div class="overview" ref="builderOverview">
      <div class="overview-head">
        <div class="overview-title">
          <span class="overview-title-main"><span v-if="builder.items.length > 1">#<span v-html="builder.currentItem.ref"></span>&nbsp;</span><span v-html="builder.currentItem.product.shortTitle"></span><span v-if="subTitle.length">: </span></span>
          <span class="overview-title-sub" v-html="subTitle"></span>
        </div>
        <div class="overview-subtitle" v-if="builder.currentItem.productLayout.hasComponents">
          Editing Section <span v-html="builder.section"></span> of <span v-html="builder.sectionMax"></span>
        </div>
      </div>
      <div class="overview-body">
        <Plan
          @set-section="setSection"></Plan>
      </div>
      <div class="overview-image"></div>
      <div class="overview-notes">
        Visual configuration only, not to scale
      </div>
    </div>

    <div class="progressbar" data-breakmin="mama">
      <div class="progressbar-head">My Progress</div>
      <div class="progressbar-bar">
        <div class="progressbar-done" :data-status="progressBarStatus" :style="`width: ${builder.currentItem.percentage}%;`">
          <div class="progressbar-num"><span v-html="builder.currentItem.percentage"></span>%</div>
        </div>
      </div>
    </div>

    <button class="button l_icon l_strong-but-subtle" data-breakmin="mama" v-if="builder.mode == 'build' && builder.step < builder.stepMax+1" @click.stop="saveAndContinue($event)" style="margin-top: 20px;">
      <span class="btn-text" v-html="builder.steps[builder.step-1].nextText"></span>
      <span class="btn-icon">
        <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
      </span>
    </button>

    <a :href="builder.messages.noOptionsLinkUrl" class="button l_icon l_strong-but-subtle l_base" style="margin-top: 20px;" v-if="builder.range.handle !== 'wardrobes'">
      <span class="btn-text">Book a Design Consult</span>
      <span class="btn-icon">
        <svg class="icon"><use xlink:href="#help-talk"></use></svg>
      </span>
    </a>

  </template>

  <template v-else-if="builder.mode == 'quote'">

    <div class="miniquote">
      <div class="miniquote-head">Your myDIY Quote</div>
      <div class="miniquote-main">

        <div class="miniquote-row" v-for="(item, index) in builder.items">
          <div class="miniquote-title" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; margin-right: 12px;" v-html="item.title"></div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(item.total)"></div>
          <div class="miniquote-price l_blurred" v-else>$0,000.00</div>
        </div>

        <div class="miniquote-row" v-for="(adjuster, index) in builder.quote.adjusters" v-if="builder.quote.adjusters && builder.quote.adjusters.length && builder.quote.valid">
          <div class="miniquote-title" v-html="adjuster.formattedTitle"></div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(adjuster.calcTotal)"></div>
          <div class="miniquote-price l_blurred" v-else>$0,000.00</div>
        </div>

        <div class="miniquote-row l_subtotal" v-if="builder.quote.totalItemsCost && builder.quoteNeedsSubtotal && builder.quoteHasMultipleItems">
          <div class="miniquote-title">Subtotal</div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalItems)"></div>
          <div class="miniquote-price l_blurred" v-else>$0,000.00</div>
        </div>

        <div class="miniquote-row l_subtotal" v-if="builder.quote.totalDiscount != 0">
          <div class="miniquote-title" style="color:red;" v-html="builder.quote.discountShortTitle"></div>
          <div class="miniquote-price" style="color:red;" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalDiscount)"></div>
          <div class="miniquote-price l_blurred" style="color:red;" v-else>$000.00</div>
        </div>

        <div class="miniquote-row l_subtotal" v-if="builder.quote.totalDeliveryCost && builder.range.handle !== 'kitchens' && builder.range.handle !== 'laundry' && builder.quoteNeedsSubtotal">
          <div class="miniquote-title">Delivery <span v-if="!builder.isKlBuilder && builder.quote.postcode">To {{ builder.quote.postcode }}</span></div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable && !builder.quote.isCustomDelivery">
            <template v-if="builder.quote.discountFreeDelivery && builder.quote.deliveryType == 'delivery'"><strike v-html="builder.displayPriceIncludeGst(builder.quote.totalDelivery)"></strike>&nbsp;&nbsp;<template v-if="builder.quote.totalDeliveryAfterDiscount != 0"><span v-html="builder.displayPriceIncludeGst(builder.quote.totalDeliveryAfterDiscount)"></span></template><template v-else>Free</template></template>
            <template v-else>
              <span v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(builder.quote.totalDelivery)"></span>
              <span v-else>$000.00</span>
            </template>
          </div>
          <div class="miniquote-price" v-else-if="builder.quoteIsViewable && builder.quote.isCustomDelivery">TBC</div>
          <div class="miniquote-price l_blurred" v-else>$000.00</div>
        </div>

        <!-- <div class="miniquote-row l_subtotal" v-if="builder.quote.totalTaxCost">
          <div class="miniquote-title">GST</div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable" v-html="builder.quote.totalTaxCost"></div>
          <div class="miniquote-price" v-else>$000.00</div>
        </div> -->

        <div class="miniquote-row l_total" v-if="builder.quote.totalCost">
          <div class="miniquote-title">
            <div>Quote Total</div>
            <div class="miniquote-title-help">Inc. GST</div>
          </div>
          <div class="miniquote-price" v-if="builder.quoteIsViewable" v-html="builder.quote.totalCost"></div>
          <div class="miniquote-price l_blurred" v-else>$0,000.00</div>
        </div>

      </div>
    </div>

    <div class="flex-buttons" :class="{ 'flex-buttons' : builder.isKlBuilder }">

      <button class="button l_icon l_strong-but-subtle l_small-text" :class="{ 's_disabled' : builder.currentItem.validStep == 0 }" v-if="builder.isKlBuilder && !builder.quote.ordered && (!(builder.quote.isCustom || builder.currentItem.isCustom) || builder.isCp)" @click.stop="editItem($event)">
        <span class="btn-text">Edit Quote</span>
        <span class="btn-icon">
          <svg class="icon"><use xlink:href="#pencil"></use></svg>
        </span>
      </button>

      <button class="button l_icon l_strong-but-subtle l_small-text" :class="{ 's_disabled' : builder.currentItem.validStep == 0 }" v-if="builder.mode == 'quote' && (!builder.quote.isCustom || builder.isCp)" @click.stop="saveAndExit($event, 'save')">
        <span class="btn-text" v-if="builder.isKlBuilder">Email Quote</span>
        <span class="btn-text" v-else>Save Quote</span>
        <span class="btn-icon">
          <svg class="icon"><use xlink:href="#email"></use></svg>
        </span>
      </button>

      <button class="button l_icon l_strong-but-subtle l_small-text" :class="{ 's_disabled' : builder.currentItem.validStep == 0 }" v-if="builder.mode == 'quote' && (!builder.quote.isCustom || builder.isCp)" @click.stop="share($event)">
        <span class="btn-text">Share Quote</span>
        <span class="btn-icon">
          <svg class="icon"><use xlink:href="#share"></use></svg>
        </span>
      </button>

    </div>

    <template v-if="builder.isKlBuilder">

      <a href="https://www.cabnt.com.au/request-a-quote" target="_blank" class="button-with-pop button-with-pop--reverse button-with-pop--small" style="margin-top: 60px;">
        <div class="button-with-pop__inner">
          <div class="button-with-pop__main">
            <div class="button-with-pop__subtitle">
              Book a Design Consultation
            </div>
          </div>
          <div class="button-with-pop__image">
            <img src="/images/btn-speak.png" alt="">
          </div>
        </div>
      </a>

      <a href="https://www.cabnt.com.au/request-a-quote" target="_blank" class="button-with-pop" style="margin-top: 20px;">
        <div class="button-with-pop__inner">
          <div class="button-with-pop__main">
            <div class="button-with-pop__subtitle">
              Looking for a more customised solution
            </div>
            <div class="button-with-pop__title">
              <img src="/images/cabnt/logo-reverse.svg" alt="Cabnt">
            </div>
            <div class="button-with-pop__icon">
              <svg class="icon"><use href="#arrow-right"></use></svg>
            </div>
          </div>
          <div class="button-with-pop__image">
            <img src="/images/btn-ben.png" alt="">
          </div>
        </div>
        <div class="button-with-pop__extra-text">
          Guaranteed to fit! *
        </div>
      </a>

    </template>

    <template v-if="!builder.quote.isReadyForOrder && !builder.quote.isCustomDelivery">
      <p style="margin: 10px 0 0; font-size: 70%;">Please <a href="#your-postcode" style="color: #000;">enter your postcode</a> to continue.</p>
    </template>

    <button class="button l_icon l_softred l_strong-but-subtle" :class="{ 's_disabled' : ( (builder.step >= builder.stepValid) || !builder.quote.deliveryType || !builder.quote.valid || (!builder.quote.isReadyForOrder && !builder.quote.isCustomDelivery) ) }" @click.stop="orderNow($event)" style="margin-top: 20px;">
      <span class="btn-text" v-if="builder.quote.isCustomDelivery">Submit for Custom Delivery Quote</span>
      <span class="btn-text" v-else>Order Now</span>
      <span class="btn-icon">
        <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
      </span>
    </button>

    <div class="miniquote-security">
      <img src="/images/payment-methods/visa.svg" alt="Visa">
      <img src="/images/payment-methods/mastercard.svg" alt="Mastercard">
      <img src="/images/payment-methods/amex.svg" alt="American Express">
    </div>

    <!-- <small style="text-align: center; margin-top: 6px; opacity: 0.75;">For 30 days</small> -->

  </template>

  <Features v-if="builder.mode == 'build' && builder.currentItem.validStep >= 3"></Features>

</template>

<script setup>

import { reactive, computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const progressBarStatus = computed(() => {
  return builder.currentItem.percentage < 30 ? 'low' : 'high';
})

const emit = defineEmits(['orderNow', 'saveAndContinue', 'saveAndExit'])

const subTitle = computed(() => {
  if (builder.currentItem.productId == 1 || builder.currentItem.productId == 7 || builder.currentItem.productId == 8) {
    console.log(builder.currentItem.data);
    if (builder.currentItem.data.wallSpace && builder.currentItem.data.wallSpace.title) {
      let newstr = builder.currentItem.data.wallSpace.title.replace(/\((.+?)\)/g, '');
      return newstr;
    } else {
      return '';
    }
  }
  return builder.currentItem.productLayout.title;
})

function setSection(num) {
  if (num <= builder.currentItem.validSection) {
    if (confirm('Are you sure you want to change the section you\'re editing? Any unsaved changes will be lost.')) {
      builder.setSection(num);
    }
  }
}

function orderNow(e) {
  emit('orderNow', e);
}

function saveAndContinue(e) {
  emit('saveAndContinue', e);
}

function saveAndExit(e) {
  window.location = '/builder/save/';
  return false;
}

function share(e) {
  window.location = '/builder/share/';
  return false;
}

function editItem(e) {
  let submitData = {
    itemId: builder.currentItem.id
  };
  builder.actionPost('item/edit', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.setItemId(response.item.id);
      builder.validateCurrentItem();
      builder.setMode('build');
      builder.setStep(2);
    }
  });
  return false;
}

// init refs
const builderOverview = ref(null);
builder.refs['builderOverview'] = builderOverview;
</script>
